import { __awaiter, __generator } from "tslib";
import React, { useContext, useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { FilterContext } from "@contexts/FilterContext";
import { IndustryAPIContext } from "@shared/contexts/api";
import { IndustryExtractor } from "@shared/models/industry";
import { CollapsibleInlineFilter } from "./CollapsibleInlineFilter";
export var IndustryFilter = React.memo(function (props) {
    var filterKey = props.filterKey, isCollapsed = props.isCollapsed, onToggle = props.onToggle;
    var intl = useIntl();
    var industryAPI = useContext(IndustryAPIContext);
    var _a = useContext(FilterContext), appliedFilters = _a.appliedFilters, setAppliedFilter = _a.setAppliedFilter;
    var fetchOptions = useCallback(function (page, perPage, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, industryAPI.listIndustries({
                    page: page,
                    perPage: perPage,
                    search: options.search,
                })];
        });
    }); }, [industryAPI]);
    var onSelect = useCallback(function (items) {
        setAppliedFilter({ industries: items });
    }, [setAppliedFilter]);
    var title = useMemo(function () {
        return intl.formatMessage({ id: "common.tags.industry" });
    }, [intl]);
    var searchPlaceholder = useMemo(function () {
        return intl.formatMessage({ id: "common.search" });
    }, [intl]);
    var onToggleFilter = useCallback(function () {
        onToggle(filterKey);
    }, [filterKey, onToggle]);
    return (React.createElement(CollapsibleInlineFilter, { isCollapsed: isCollapsed, onToggle: onToggleFilter, selected: appliedFilters.industries, onSelect: onSelect, getOptions: fetchOptions, title: title, searchPlaceholder: searchPlaceholder, labelExtractor: IndustryExtractor.name, descriptionExtractor: IndustryExtractor.fullName, keyExtractor: IndustryExtractor.id }));
});
